module.exports = __webpack_public_path__ + "media/images/home/aim-50f41e3b2845f0d753684f66028d3b02.svg";